module.exports = __webpack_public_path__ + "img/share_5a130.png";